<template>
	<v-toolbar
		ref="toolbarList"
		class="secondary"
		flat
		height="47"
		v-if="orderColumns.items"
	>
		<v-container pa-0>
			<v-layout row>
				<v-flex d-flex align-center>
					<v-tabs
						:key="viewList.key"
						color="transparent"
						dark
						hide-slider
						:show-arrows="viewList.rowing == true ? false : true"
						height="47px"
						:value="orderColumns.column ? orderColumns.column.id : null"
					>
						<v-layout row justify-space-between>
							<template v-for="(v, i) in orderColumns.items">	
								<v-flex
									class="d-flex align-center"
									:class="[`${!$store.state.menu.isMobile && viewList.rowing ? v.classes.list : ''}`]"
									:key="i"
								>
									<v-tab
										class="white--text text-none body-1 pr-2"
										:class="[{'text-xs-left tabClass': viewList.rowing}]"
										:href="v.id"
										:ripple="false"
										@click.prevent="changeOrder(i)"
									>
										<div class="d-inline-flex justify-start align-center body-1 font-weight-regular navbartext--text line-height">
											<span class="mr-1">{{ v.name }}</span>
											<v-icon :class="[`${orderColumns.column.id == v.id ? 'info' : 'navbartext'}--text`]" size="14" v-if="v.order == 'desc'">
												arrow_downward
											</v-icon>
											<v-icon :class="[`${orderColumns.column.id == v.id ? 'info' : 'navbartext'}--text`]" size="14" v-if="v.order == 'asc'">
												arrow_upward
											</v-icon>
										</div>
									</v-tab>
								</v-flex>
							</template>
							<v-flex
								v-if="viewList.rowing"
								class="text-xs-right"
								:class="[{'grow': viewList.rowing}]"
							>
								<!-- Acciones label -->
							</v-flex>
						</v-layout>
					</v-tabs>
				</v-flex>
			</v-layout>
		</v-container>
	</v-toolbar>
</template>

<script>
// import compSearchField from '@/components/TextField/SearchField'

import { mapState } from 'vuex'
export default {
	computed: {
		...mapState('listItems', ['orderColumns', 'viewList'])
	},
	methods: {
		changeOrder(i) {
			this.$store.dispatch('listItems/changeOrder', {index: i})
			this.orderColumns.refreshFunction(true)
		}
	}
}
</script>

<style lang="scss">
.tabClass {
	& > a {
		display: inline-block;
		text-align: left;
		padding: 0px;
	}
}
</style>


